import { render } from "./AppLoading.vue?vue&type=template&id=86dc635e"
import script from "./AppLoading.vue?vue&type=script&lang=js"
export * from "./AppLoading.vue?vue&type=script&lang=js"
script.render = render

export default script